/**
 * this renders on https://local.hungryroot.com/products/fresh-zucchini-757/
 * This file is a temporary wrapper for the new React based
 * PDP (Product Details Page) to replace the legacy version
 * built with with CoffeeScript. To keep footprints small,
 * we start by only replacing the dialog part, but the next
 * step is definitely to change the card-rendering to be completely
 * react as well
 */

import { Component } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { client } from '../../../components/rest/react-query';
import { combineReducers } from 'redux';
import { Provider } from 'react-redux';
import PDPModalContainer from './pdp_modal_wrapper/PDPModalContainer';
import { renderApp } from './utils/utils';
import configureStore from './utils/configure_store';
import { tag } from './generic/global_state/reducers';

const store = configureStore(combineReducers({ tag }));

class PDPModalWrapper extends Component {
  constructor(props) {
    super(props);

    // Expose the API for coffee script
    window.PDPModalWrapper = window.PDPModalWrapper || this;
    this.state = {
      product: null,
      visible: false,
      closeModalCallback: null, // Reserved for coffeescript to hook in the callback
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal(productId, closeModalCallback) {
    this.setState({
      closeModalCallback,
      product: { id: productId },
      visible: true,
    });
  }

  closeModal() {
    if (!this.state.product && !this.state.visible) {
      return;
    }

    this.setState({
      product: null,
      visible: false,
    });

    if (this.state.closeModalCallback) {
      this.state.closeModalCallback();
    }
  }

  render() {
    return (
      <Provider store={store}>
        <QueryClientProvider client={client}>
          {this.state.product && (
            <PDPModalContainer
              product={this.state.product}
              visible={this.state.visible}
              togglePdpModal={() => this.closeModal()}
            />
          )}
        </QueryClientProvider>
      </Provider>
    );
  }
}

renderApp(<PDPModalWrapper />, 'pdp-modal-container');
